export enum BackgroundAction {
  ApiRequest = '[Background] ApiRequest',
  ClearApiRequestCache = '[Background] ClearApiRequestCache',
  ExtensionAuthStatusChanged = '[Background] ExtensionAuthStatusChanged',
  GetBackendUrl = '[Background] GetBackendUrl',
  GetCopilotScripts = '[Background] GetCopilotScripts',
  GetExtensionSignedInStatus = '[Background] GetExtensionSignedInStatus',
  GetLatestDashboardMessage = '[Background] GetLatestDashboardMessage',
  GetLocalStorage = '[Background] GetLocalStorage',
  GetProfileEmail = '[Background] GetProfileEmail',
  GetTabId = '[Background] GetTabId',
  GetThirdPartyAppCredentials = '[Background] GetThirdPartyAppCredentials',
  GetThirdPartyAppCredentialsPopupDetails = '[Background] GetThirdPartyAppCredentialsPopupDetails',
  GetUserDetails = '[Background] GetUserDetails',
  InjectContent = '[Background] InjectContent',
  LoadRecommendations = '[Background] LoadRecommendations',
  SignIn = '[Background] SignIn',
  SignOut = '[Background] SignOut',
  NavigateToUrl = '[Background] NavigateToUrl',
  Ping = '[Background] Ping',
  SendCopilotNotificationFeedback = '[Background] SendCopilotNotificationFeedback',
  SetLocalStorage = '[Background] SetLocalStorage',
  TrackAnalyticsEvent = '[Background] TrackAnalyticsEvent',
  UpdateIsExtensionPopupOpened = '[Background] UpdateIsExtensionPopupOpened',
  UpdateUserDetails = '[Background] UpdateUserDetails',
  // Shared actions in copilot scripts and extension
  GetCopilotNotificationConfigurations = 'getCopilotNotificationConfigurations',
}
